import { create } from "zustand";
import { getEmployees } from "../services/api";

const useAdminEmployeeStore = create((set, get) => ({
	employees: [],
	hydrated: false,
	loading: false,
	error: "",

	hydrateEmployees: async () => {
		if (get().loading || get().hydrated) {
			return;
		}

		set({ loading: true, error: "" });

		try {
			const data = await getEmployees();
			set({
				employees: Array.isArray(data) ? data : [],
				hydrated: true,
				loading: false,
				error: "",
			});
		} catch (err) {
			set({
				employees: [],
				hydrated: false,
				loading: false,
				error: err?.message || "Failed to load employees",
			});
		}
	},

	resetEmployees: () =>
		set({
			employees: [],
			hydrated: false,
			loading: false,
			error: "",
		}),
}));

export default useAdminEmployeeStore;